class SlideshowAutoplayIndicator extends HTMLElement {
  #slideshow = null;
  #onSelect = null;
  #pausedObserver = null;

  connectedCallback() {
    this.#slideshow = this.closest('slideshow-component');
    if (!this.#slideshow) return;

    const intervalSeconds = parseInt(this.#slideshow.getAttribute('autoplay') || '', 10);
    if (Number.isFinite(intervalSeconds) && intervalSeconds > 0) {
      this.style.setProperty('--autoplay-duration', `${intervalSeconds}s`);
    }

    this.#onSelect = (event) => {
      // Only restart the countdown when the slide actually changed. A pure
      // click (no drag) still dispatches a select event with the same index —
      // ignoring those keeps the timer running instead of resetting on click.
      const detail = /** @type {{ detail?: { index?: number, previousIndex?: number } }} */ (event).detail;
      if (detail && detail.index === detail.previousIndex) return;
      this.#restartRing();
    };
    this.#slideshow.addEventListener('slideshow:select', this.#onSelect);

    this.#pausedObserver = new MutationObserver(() => this.#syncPausedState());
    this.#pausedObserver.observe(this.#slideshow, {
      attributes: true,
      attributeFilter: ['paused'],
    });

    this.#syncPausedState();
  }

  disconnectedCallback() {
    if (this.#slideshow && this.#onSelect) {
      this.#slideshow.removeEventListener('slideshow:select', this.#onSelect);
    }
    this.#pausedObserver?.disconnect();
    this.#pausedObserver = null;
    this.#slideshow = null;
    this.#onSelect = null;
  }

  #syncPausedState() {
    if (!this.#slideshow) return;
    this.toggleAttribute('paused', this.#slideshow.hasAttribute('paused'));
  }

  #restartRing() {
    const ring = this.querySelector('.slideshow-autoplay-indicator__ring-progress');
    if (!ring) return;
    ring.style.animation = 'none';
    // Force reflow so the animation restarts cleanly
    void ring.getBoundingClientRect();
    ring.style.animation = '';
  }
}

if (!customElements.get('slideshow-autoplay-indicator')) {
  customElements.define('slideshow-autoplay-indicator', SlideshowAutoplayIndicator);
}
